import React from 'react';
import { Modal, Spinner } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import "./index.scss"

interface CenteredModalProps {
  show: boolean;
  message: string;
  loading?: boolean;
}

const CenteredModal: React.FC<CenteredModalProps> = ({ show, message, loading = true }) => {
  return (
    <Modal
      show={show}
      centered
    >
      <Modal.Body className="centered-modal-body">
        {loading && (
          <div className="spinner-container">
            <Spinner animation="border" variant="primary" role="status" />
          </div>
        )}
        <div className="modal-message">
          <p>{message}</p>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default CenteredModal;